import React, { useState } from "react";
import styled from "styled-components";
import { RotaDropdownHeader, RotaRadio } from "@teamrota/rota-design";

const StyledDropdownsContainer = styled.div`
  padding: 8px;
  border-radius: 4px;
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 8px;
  border: solid 1px ${({ theme }) => theme.neutral.light};
  background-color: ${({ theme }) => theme.white};
`;

const SortDropdown = ({ setSortBy, sortBy }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RotaDropdownHeader
      labelText={"Sort by..."}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(isOpen => !isOpen)}
    >
      <StyledDropdownsContainer>
        <RotaRadio
          name="FIRSTNAME"
          label="First Name"
          checked={sortBy === "FIRSTNAME"}
          onChange={e => setSortBy(e.target.name)}
        />

        <RotaRadio
          name="LASTNAME"
          label="Last Name"
          checked={sortBy === "LASTNAME"}
          onChange={e => setSortBy(e.target.name)}
        />
      </StyledDropdownsContainer>
    </RotaDropdownHeader>
  );
};

export default SortDropdown;
